import { createContext, useContext } from 'react';
import { PickerVariant } from 'interfaces/marketplace.interface';

export interface PackPreviewContextValue {
  isPreview: true;
  variant: PickerVariant;
  onClose: () => void;
}

export const PackPreviewContext = createContext<PackPreviewContextValue | null>(
  null
);

export const usePackPreviewContext = () => useContext(PackPreviewContext);
